module.exports = __webpack_public_path__ + "static/media/27-5.978e1101.mp3";